import React, { useEffect, useState } from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { RiDeleteBin5Line } from "react-icons/ri";

import { AddMore } from "../../../../../assets";
import { EMPTY_STRING, locationTypes } from "../../../../../constants";
import CustomSvg from "../../../../../shared/components/custom-svg/CustomSvg";

const NearbyLocationsForm = () => {
  const {
    register,
    control,
    formState: { errors },
    watch,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "amenity.nearbyLocations",
  });

  const [errorFields, setErrorFields] = useState([]);
  const [currentLocation, setCurrentLocation] = useState(1);

  const changeCurrentLocation = (id) => {
    setCurrentLocation(id);
  };

  const handleAddNewLocation = () => {
    append({
      key: Date.now(),
      type: currentLocation,
      name: EMPTY_STRING,
      distance: EMPTY_STRING,
    });
  };

  useEffect(() => {
    const currentErrorFields = fields
      .map((field, index) => {
        const error = errors?.amenity?.nearbyLocations?.[index];
        return error ? { index, field } : null;
      })
      .filter(Boolean); // Filter out null values
    setErrorFields(currentErrorFields.map((field) => field.field.type));

    // eslint-disable-next-line
  }, [currentLocation, errors, fields]);

  return (
    <div className="main-container-form">
      <div className="location-types">
        {locationTypes.map((locationType) => (
          <div
            key={locationType.id}
            className={`location-type ${
              currentLocation === locationType.id
                ? "selected-location"
                : errorFields.includes(locationType.id)
                ? "text-danger"
                : EMPTY_STRING
            }`}
            onClick={() => changeCurrentLocation(locationType.id)}
          >
            <CustomSvg
              src={locationType.icon}
              className="agent-create-listing-nearby-location-icon"
            />
            <div className="location-type-name">{locationType.name}</div>
          </div>
        ))}
      </div>

      {errors?.amenity?.nearbyLocations?.message && (
        <div className="error mt-2">
          {errors?.amenity?.nearbyLocations.message}
        </div>
      )}

      <div className="row locations-fields" id="fields">
        {fields
          .filter((location) => location.type === currentLocation)
          .map((field, index) => (
            <>
              <div className="col-12 col-sm-7 col-md-7 location-input-field">
                <label>Name:</label>
                <input
                  type="text"
                  className={`create-list-input ${
                    errors?.amenity?.nearbyLocations?.[
                      fields.findIndex(
                        (loc) => (loc.id ?? loc.key) === (field.id ?? field.key)
                      )
                    ]?.name
                      ? "border border-danger"
                      : EMPTY_STRING
                  }`}
                  placeholder="Name"
                  value={watch(
                    `amenity.nearbyLocations.${fields.findIndex(
                      (loc) => (loc.id ?? loc.key) === (field.id ?? field.key)
                    )}.name`
                  )}
                  {...register(
                    `amenity.nearbyLocations.${fields.findIndex(
                      (loc) => (loc.id ?? loc.key) === (field.id ?? field.key)
                    )}.name`
                  )}
                />
              </div>
              <div className="col-12 col-sm-4 col-md-4 location-input-field">
                <label>Distance (mi):</label>
                <input
                  type="text"
                  className={`create-list-input ${
                    errors?.amenity?.nearbyLocations?.[
                      fields.findIndex(
                        (loc) => (loc.id ?? loc.key) === (field.id ?? field.key)
                      )
                    ]?.distance
                      ? "border border-danger"
                      : EMPTY_STRING
                  }`}
                  value={watch(
                    `amenity.nearbyLocations.${fields.findIndex(
                      (loc) => (loc.id ?? loc.key) === (field.id ?? field.key)
                    )}.distance`
                  )}
                  placeholder="Distance"
                  {...register(
                    `amenity.nearbyLocations.${fields.findIndex(
                      (loc) => (loc.id ?? loc.key) === (field.id ?? field.key)
                    )}.distance`
                  )}
                />
              </div>
              {/* Hidden field for storing the location type */}
              <input
                type="hidden"
                {...register(
                  `amenity.nearbyLocations.${fields.findIndex(
                    (loc) => (loc.id ?? loc.key) === (field.id ?? field.key)
                  )}.type`
                )}
                value={field.type}
              />
              <div className="col-12 col-sm-1 col-md-1 d-flex justify-content-center align-items-center">
                <RiDeleteBin5Line
                  size={14}
                  onClick={() => {
                    const originalIndex = fields.findIndex(
                      (loc) => (loc.id ?? loc.key) === (field.id ?? field.key)
                    );
                    remove(originalIndex);
                  }}
                  className="mt-2 text-danger pointer"
                />
              </div>
            </>
          ))}
      </div>
      <div
        className="add-more-button pointer d-flex align-items-center gap-2"
        onClick={handleAddNewLocation}
      >
        <img src={AddMore} alt="Add More Icon" />
        <div className="add-more-text">Add More</div>
      </div>
    </div>
  );
};

export default NearbyLocationsForm;
